export default __webpack_public_path__ + "27a36b9202e25b021f52c4c43b01a70f.png";